class CollectionSeoTextDetails extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-toggle]');

      if (!toggle) return;
      if (toggle.dataset.toggle === 'open') {
        this._open();
      } else {
        this._close();
      }
    })
  }

  connectedCallback() {

  }

  disconnectedCallback() {

  }

  _open() {
    this.state = 'open';
  }

  _close() {
    this.state = 'closed';

    window.requestAnimationFrame(() => {
      this.querySelector('[data-toggle="open"]').focus();
    });
  }

  set state(state) {
    this.setAttribute('state', state);
  }
}

if (!customElements.get("collection-seo-text-details")) {
  customElements.define("collection-seo-text-details", CollectionSeoTextDetails);
}
